export default "__VITE_ASSET__DciPhC$w__"